(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Vue"), require("accountsApi"), require("systemsApi"), require("systemsComponents"));
	else if(typeof define === 'function' && define.amd)
		define("accountsComponents", ["Vue", "accountsApi", "systemsApi", "systemsComponents"], factory);
	else if(typeof exports === 'object')
		exports["accountsComponents"] = factory(require("Vue"), require("accountsApi"), require("systemsApi"), require("systemsComponents"));
	else
		root["accountsComponents"] = factory(root["Vue"], root["accountsApi"], root["systemsApi"], root["systemsComponents"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__508__, __WEBPACK_EXTERNAL_MODULE__456__, __WEBPACK_EXTERNAL_MODULE__670__, __WEBPACK_EXTERNAL_MODULE__130__) => {
return 